import request from '@/utils/request';
import { paymentServiceV1 } from '@/config/apiPrefix.config';

// 获取用户账单
export const getBillList = (data) => request(`${paymentServiceV1}/billing/get_billing_list`, {
  params: data,
});

// 获取当前已有的活动
export const getCurrentActivity = (data) => request(`${paymentServiceV1}/activity/get_activity`, {
  params: data,
});

// 用户确认转账
export const confirmBillPay = (data) => request(`${paymentServiceV1}/billing/confirm_transfer`, {
  params: data,
  method: 'put',
});
